__turbopack_context__.v({
  "dayBox": "_4jP-KG_dayBox",
  "dayBoxUnselected": "_4jP-KG_dayBoxUnselected",
  "daysWrapper": "_4jP-KG_daysWrapper",
  "deliverySlotsList": "_4jP-KG_deliverySlotsList",
  "deliverySlotsWrapper": "_4jP-KG_deliverySlotsWrapper",
  "slotsColumn": "_4jP-KG_slotsColumn",
  "wrapper": "_4jP-KG_wrapper",
});
